import { isPartnersEnv } from 'App/constants';
import uniq from 'lodash/uniq';

import { object, string, array, boolean } from '@gogame/schemas';

const goGameDefaultColumns = [
  'RegsUniqueInstalls',

  'SpentUsd',
  'TotalCpi',
  'TotalRegs',

  'TotalDepositors',
  'TotalDeposits',
  'TotalDepositorsPercent',
  'TotalDepositAmount',

  'TotalCpd',
  'ROITotal',
  'TotalRoasD0',
  'TotalRoasD3',
  'TotalRoasD7',
  'TotalRoasD30',
  'Day1RPercent',
  'Day7RPercent',
];

const partnersDefaultColumns = [
  'RegActions',
  'ClickToRegConversion',
  'Clicks',
  'Depositors',
  'DepositorsPercent',
  'Day1RPercent',
  'Day7RPercent',
  'Day30RPercent',
  'FiveQuestPercent',
];
export const columnsSchema = object({
  order: array(string()).default(
    uniq(isPartnersEnv ? partnersDefaultColumns : goGameDefaultColumns)
  ),
  percentage: array(string()).default([]),
  collapsed: array(string()).default([]),
  scaled: array(string()).default([]),
  isAllScaled: boolean().default(false),
});
